import {GetRegistrationUpdateStatusParams} from 'domain/usecases/private/home/registration-update-status';
import {makeGetRegistrationUpdateStatus} from 'main/factories/usecases/private/remote-home/get-registration-update-status-factory';

export const getRegistrationUpdateStatus = async (params: GetRegistrationUpdateStatusParams) => {
	const response = await makeGetRegistrationUpdateStatus().get(params);
	return response;
};
